import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#de7119",
    },
    secondary: {
      main: "#072e36",
    }
  },
});

export default theme;